import { Badge, Table } from "react-bootstrap";
import blogFetch from "../../axios/config";
import { DateFmt } from "../../utils/DataUtils";

// Cor do bootstrap para cada status vindo do back.
const CORES = {
  // colaborador: Liberado | Pendente | Bloqueado — documento: Ativo | Pendente | Bloqueado
  Liberado: "success",
  Ativo: "success",
  Pendente: "warning",
  Bloqueado: "danger",
  // empresa e análise do documento
  Ativa: "success",
  Aprovado: "success",
  "Em análise": "warning",
  "Aguardando análise": "warning",
  Bloqueada: "danger",
  Reprovado: "danger",
  Inativa: "secondary",
};

const ICONES = { success: "✓", warning: "⏳", danger: "✕" };

export const corStatus = (status) => CORES[status] || "secondary";

// Datas do SGA chegam como int YYYYMMDD.
export const dataHse = (data) => (data ? DateFmt(String(data)) : "-");

// Abre (nova aba) ou baixa o arquivo de um documento enviado.
export const arquivoDocumento = async (doc, baixar = false) => {
  const res = await blogFetch.get(`/sga/document/${doc.id}/file`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);

  if (!baixar) {
    window.open(url, "_blank");
    return;
  }

  const link = window.document.createElement("a");
  link.href = url;
  link.download = doc.arquivo || `${doc.tipo}_v${doc.versao}`;
  link.click();
  URL.revokeObjectURL(url);
};

const BadgeStatus = ({ status, children, ...props }) => {
  const cor = corStatus(status);
  return (
    <Badge bg={cor} text={cor === "warning" ? "dark" : undefined} {...props}>
      {children}
    </Badge>
  );
};

export const StatusHse = ({ status, grande }) => (
  <BadgeStatus status={status} className={grande ? "fs-6 px-3 py-2" : ""}>
    {grande ? status?.toUpperCase() : status}
  </BadgeStatus>
);

// Uma etiqueta por documento obrigatório; a validade aparece no hover.
export const DocumentosChips = ({ documentos }) => (
  <div className="d-flex flex-wrap gap-1">
    {documentos?.map((d) => (
      <BadgeStatus
        key={d.tipo}
        status={d.status}
        title={`${d.status} · validade ${dataHse(d.dataValidade)}`}
        className="fw-semibold"
        style={{ fontSize: "0.85rem" }}
      >
        {ICONES[corStatus(d.status)]} {d.tipo}
      </BadgeStatus>
    ))}
  </div>
);

export const DocumentosHse = ({ documentos }) => (
  <Table size="sm" bordered className="mb-0 align-middle text-center">
    <thead className="table-light">
      <tr>
        <th>Documento</th>
        <th>Situação</th>
        <th>Validade</th>
      </tr>
    </thead>
    <tbody>
      {documentos?.map((d) => (
        <tr key={d.tipo}>
          <td>{d.tipo}</td>
          <td><StatusHse status={d.status} /></td>
          <td>{dataHse(d.dataValidade)}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);
